import { Record } from '@ltvco/refresh-lib/v1';
import { NoResultsFound } from '@ltvco/refresh-lib/v2';

import { PersonCards } from '../Cards/PersonCards';
import { PersonCardLoading } from '../Loading/PersonCardLoading';

interface PersonResultsContainerProps {
  results: Record[] | undefined;
}

export function PersonResultsContainer({
  results,
}: PersonResultsContainerProps) {
  return !results ? (
    <PersonCardLoading />
  ) : results.length <= 0 ? (
    <NoResultsFound />
  ) : (
    <PersonCards searchPersonResult={results} />
  );
}
